import { useMutation } from '@tanstack/react-query';

import { HttpClient } from '@/network/HttpClient';

export const useFiscalizationCashierActionMutation = <TResponse>() =>
  useMutation({
    mutationFn: (params: { url: string; cashierId: number }) =>
      HttpClient.request<TResponse>({
        method: 'POST',
        url: params.url,
        data: { cashier_id: params.cashierId },
      }),
  });
